import { COUNTRY_FLAG_REFERENCES } from 'constants';
import styled from 'styled-components';

const ExchangeRateItemMobile = ({ country, rates, isActive, onClick }) => {
  if (Object.keys(rates).length === 0) return null;
  return (
    <ItemWrap $isActive={isActive} onClick={onClick}>
      <FlagIcon src={COUNTRY_FLAG_REFERENCES[country]} />
    </ItemWrap>
  );
};

const ItemWrap = styled.div`
  border-bottom: ${(props) =>
    props.$isActive ? '3px solid var(--c-quaternary)' : 'none'};
  padding-bottom: 7px;
`;

const FlagIcon = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid var(--ds-c-black-disabled);
`;

export default ExchangeRateItemMobile;
